import { readCachedUser } from "../utils/cachedUser";
import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  collection,
  addDoc,
  onSnapshot,
  query,
  where,
  orderBy,
  serverTimestamp,
  getDocs,
  doc,
} from "firebase/firestore";
import { auth, db } from "../firebase";
import { signOut } from "firebase/auth";
import FloatingContact from "../components/FloatingContact";
import NotificationBell from "../components/NotificationBell";
import { perfMark } from "../utils/perf";
import Icon from "../components/Icon";

const css = `
*{box-sizing:border-box;margin:0;padding:0;}
  .hp{min-height:100vh;background:var(--bg);color:var(--text);font-family:'Prompt',sans-serif;}
  .hp-nav{display:flex;align-items:center;justify-content:space-between;padding:6px 40px;background:var(--surface);border-bottom:1px solid var(--border);position:sticky;top:0;z-index:10;height:64px;overflow:visible;}
  .hp-logo{display:flex;align-items:center;}
  .hp-logo span{color:var(--text);}
  .hp-logo-img{height:80px;width:auto;mix-blend-mode:screen;filter:brightness(1.1);}
  .hp-nav-right{display:flex;align-items:center;gap:12px;}
  .hp-av{width:34px;height:34px;border-radius:50%;background:linear-gradient(135deg,#1a3a25,#2a5a35);display:flex;align-items:center;justify-content:center;font-size:0.85rem;font-weight:700;color:var(--accent);}
  .hp-uname{font-size:0.82rem;color:var(--text-muted);}
  .hp-logout{padding:7px 14px;border-radius:var(--radius-full);border:1px solid var(--border);background:transparent;color:var(--text-muted);font-family:'Prompt',sans-serif;font-size:0.78rem;cursor:pointer;transition:all 0.2s;}
  .hp-logout:hover{border-color:var(--danger);color:var(--danger);}
  .hp-nav-btn{padding:7px 14px;border-radius:var(--radius-full);border:1px solid var(--border);background:transparent;color:var(--text-muted);font-family:'Prompt',sans-serif;font-size:0.78rem;cursor:pointer;transition:all 0.2s;display:flex;align-items:center;gap:5px;}
  .hp-nav-btn:hover{border-color:var(--accent);color:var(--accent);}
  .hp-nav-btn.wallet{border-color:rgba(247,71,53,0.25);color:var(--accent);background:rgba(247,71,53,0.06);}
  .hp-wallet-bal{font-size:0.7rem;font-weight:700;}
  .hp-profile-dropdown{position:relative;}
  .hp-profile-menu{position:absolute;top:calc(100% + 8px);right:0;background:var(--surface);border:1px solid var(--border);border-radius:var(--radius);padding:8px;min-width:160px;z-index:100;box-shadow:0 8px 24px rgba(0,0,0,0.3);}
  .hp-profile-item{display:flex;align-items:center;gap:8px;padding:9px 12px;border-radius:8px;font-size:0.82rem;color:var(--text-muted);cursor:pointer;transition:all 0.2s;border:none;background:transparent;width:100%;text-align:left;font-family:'Prompt',sans-serif;}
  .hp-profile-item:hover{background:var(--surface2);color:var(--text);}
  .hp-profile-item.danger:hover{color:var(--danger);}
  .hp-divider{height:1px;background:var(--border);margin:4px 0;}
  .hp-body{max-width:760px;margin:0 auto;padding:36px 24px;}
  .hp-h1{font-family:'DM Serif Display',serif;font-size:2rem;margin-bottom:6px;}
  .hp-h1 em{font-style:italic;color:var(--accent);}
  .hp-sub{color:var(--text-muted);font-size:0.85rem;margin-bottom:28px;}
  .hp-actions{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-bottom:32px;}
  .hp-action-card.game{background:rgba(124,92,255,0.07);border-color:rgba(124,92,255,0.3);}
  .hp-action-card.game:hover{border-color:rgba(124,92,255,0.6);}
  .hp-action-card{padding:20px;background:var(--surface);border:1px solid var(--border);border-radius:var(--radius);cursor:pointer;transition:all 0.2s;}
  .hp-action-card:hover{border-color:rgba(247,71,53,0.35);transform:translateY(-2px);}
  .hp-action-card.primary{background:rgba(247,71,53,0.06);border-color:rgba(247,71,53,0.25);}
  .hp-action-icon{font-size:1.6rem;margin-bottom:10px;}
  .hp-action-title{font-size:0.95rem;font-weight:700;margin-bottom:4px;}
  .hp-action-desc{font-size:0.75rem;color:var(--text-muted);line-height:1.5;}
  .hp-search-box{display:flex;gap:10px;margin-bottom:32px;}
  .hp-search-input{flex:1;padding:12px 16px;background:var(--surface);border:1px solid var(--border);border-radius:var(--radius);color:var(--text);font-family:'Prompt',sans-serif;font-size:0.88rem;outline:none;transition:border-color 0.2s;}
  .hp-search-input:focus{border-color:rgba(247,71,53,0.4);}
  .hp-search-input::placeholder{color:var(--text-muted);}
  .hp-search-btn{padding:12px 20px;background:var(--accent);border:none;border-radius:var(--radius);color:#f5f6f8;font-family:'Prompt',sans-serif;font-size:0.88rem;font-weight:700;cursor:pointer;white-space:nowrap;transition:all 0.2s;}
  .hp-search-btn:hover{background:var(--accent2);}
  .hp-sec-label{font-size:0.7rem;letter-spacing:2px;text-transform:uppercase;color:var(--text-muted);margin-bottom:10px;}
  .hp-filter-bar{display:flex;gap:6px;flex-wrap:wrap;margin-bottom:14px;align-items:center;}
  .hp-filter-btn{padding:5px 12px;border-radius:var(--radius-full);border:1px solid var(--border);background:transparent;color:var(--text-muted);font-family:'Prompt',sans-serif;font-size:0.72rem;cursor:pointer;transition:all 0.18s;white-space:nowrap;}
  .hp-filter-btn.active{background:rgba(247,71,53,0.1);border-color:rgba(247,71,53,0.35);color:var(--accent);}
  .hp-filter-btn:hover:not(.active){border-color:rgba(247,71,53,0.2);color:var(--text);}
  .hp-sort-select{padding:5px 10px;border-radius:var(--radius-full);border:1px solid var(--border);background:var(--surface2);color:var(--text-muted);font-family:'Prompt',sans-serif;font-size:0.72rem;cursor:pointer;outline:none;margin-left:auto;}
  .hp-sort-select:focus{border-color:rgba(247,71,53,0.35);}
  .hp-filter-count{font-size:0.7rem;color:var(--text-muted);margin-left:4px;}
  .hp-rooms{display:flex;flex-direction:column;gap:10px;}
  .hp-room{display:flex;align-items:center;gap:14px;padding:16px 18px;background:var(--surface);border:1px solid var(--border);border-radius:var(--radius);cursor:pointer;transition:all 0.2s;}
  .hp-room:hover{border-color:rgba(247,71,53,0.3);transform:translateY(-2px);box-shadow:0 6px 20px rgba(0,0,0,0.2);}
  .hp-room-icon{width:42px;height:42px;border-radius:12px;background:rgba(247,71,53,0.08);display:flex;align-items:center;justify-content:center;font-size:1.2rem;flex-shrink:0;}
  .hp-room-info{flex:1;min-width:0;}
  .hp-room-name{font-size:0.9rem;font-weight:600;margin-bottom:3px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
  .hp-room-meta{font-size:0.72rem;color:var(--text-muted);}
  .hp-room-code{font-size:0.68rem;color:var(--accent);font-family:'DM Mono',monospace;background:rgba(247,71,53,0.08);padding:2px 8px;border-radius:6px;margin-top:4px;display:inline-block;}
  .hp-room-right{display:flex;flex-direction:column;align-items:flex-end;gap:6px;flex-shrink:0;}
  .hp-badge{padding:3px 10px;border-radius:var(--radius-full);font-size:0.65rem;font-weight:600;}
  .hp-badge.created{background:rgba(255,179,71,0.1);color:var(--warning);border:1px solid rgba(255,179,71,0.2);}
  .hp-badge.deposited{background:rgba(85,153,255,0.1);color:#5599ff;border:1px solid rgba(85,153,255,0.2);}
  .hp-badge.shipped{background:rgba(247,71,53,0.1);color:var(--accent);border:1px solid rgba(247,71,53,0.2);}
  .hp-badge.completed{background:rgba(247,71,53,0.15);color:var(--accent);border:1px solid rgba(247,71,53,0.3);}
  .hp-badge.disputed{background:rgba(255,85,85,0.1);color:var(--danger);border:1px solid rgba(255,85,85,0.2);}
  .hp-copy-btn{font-size:0.68rem;color:var(--text-muted);background:none;border:none;cursor:pointer;font-family:'Prompt',sans-serif;padding:0;}
  .hp-copy-btn:hover{color:var(--accent);}
  .hp-empty{text-align:center;padding:48px 20px;color:var(--text-muted);}
  .hp-empty-icon{font-size:2.8rem;margin-bottom:12px;}
  .hp-empty-title{font-size:0.95rem;font-weight:600;color:var(--text);margin-bottom:6px;}
  .hp-empty-sub{font-size:0.82rem;line-height:1.6;}
  .hp-loading{display:flex;align-items:center;justify-content:center;gap:8px;padding:32px;color:var(--text-muted);font-size:0.85rem;}
  .hp-spinner{width:18px;height:18px;border:2px solid var(--border);border-top-color:var(--accent);border-radius:50%;animation:spin 0.8s linear infinite;}
  @keyframes spin{to{transform:rotate(360deg)}}
  .modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.7);backdrop-filter:blur(8px);z-index:200;display:flex;align-items:center;justify-content:center;padding:20px;}
  .modal-box{background:var(--surface);border:1px solid var(--border);border-radius:20px;padding:30px;width:100%;max-width:420px;}
  .modal-title{font-size:1.1rem;font-weight:700;margin-bottom:6px;}
  .modal-sub{font-size:0.8rem;color:var(--text-muted);margin-bottom:22px;line-height:1.6;}
  .form-group{margin-bottom:14px;}
  .form-label{display:block;font-size:0.75rem;color:var(--text-muted);margin-bottom:6px;}
  .form-input{width:100%;padding:11px 14px;background:#f5f6f8;border:1px solid var(--border);border-radius:10px;color:var(--text);font-family:'Prompt',sans-serif;font-size:0.86rem;outline:none;transition:border-color 0.2s;}
  .form-input:focus{border-color:rgba(247,71,53,0.45);}
  .form-input::placeholder{color:#a0a7b3;}
  .role-btns{display:flex;gap:8px;margin-bottom:18px;}
  .role-btn{flex:1;padding:11px;border-radius:10px;border:1px solid var(--border);background:transparent;color:var(--text-muted);font-family:'Prompt',sans-serif;font-size:0.83rem;cursor:pointer;transition:all 0.2s;text-align:center;}
  .role-btn.active{border-color:var(--accent);background:rgba(247,71,53,0.08);color:var(--accent);font-weight:600;}
  .create-terms-box{background:rgba(255,255,255,0.03);border:1px solid var(--border);border-radius:10px;padding:12px 14px;max-height:160px;overflow-y:auto;font-size:0.76rem;color:var(--text-muted);line-height:1.7;margin-bottom:14px;}
  .create-terms-box h4{font-size:0.8rem;color:var(--text);margin-bottom:8px;}
  .create-terms-box p{margin-bottom:6px;}
  .create-terms-check{display:flex;align-items:flex-start;gap:10px;font-size:0.8rem;color:var(--text-muted);cursor:pointer;margin-bottom:14px;line-height:1.5;}
  .create-terms-check input[type=checkbox]{width:16px;height:16px;accent-color:var(--accent);cursor:pointer;flex-shrink:0;margin-top:2px;}
  .create-terms-check.checked{color:var(--text);}
  .modal-btns{display:flex;gap:10px;margin-top:4px;}
  .btn-cancel{flex:1;padding:11px;border-radius:10px;border:1px solid var(--border);background:transparent;color:var(--text-muted);font-family:'Prompt',sans-serif;font-size:0.85rem;cursor:pointer;}
  .btn-ok{flex:1;padding:11px;border-radius:10px;border:none;background:var(--accent);color:#f5f6f8;font-family:'Prompt',sans-serif;font-size:0.85rem;font-weight:700;cursor:pointer;transition:all 0.2s;}
  .btn-ok:disabled{opacity:0.5;cursor:not-allowed;}
  .toast{position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:var(--surface);border:1px solid rgba(247,71,53,0.3);border-radius:10px;padding:10px 20px;font-size:0.82rem;color:var(--accent);z-index:300;animation:fadeup 0.3s ease;}
  @keyframes fadeup{from{opacity:0;transform:translateX(-50%) translateY(10px)}to{opacity:1;transform:translateX(-50%) translateY(0)}}
  .error-msg{background:rgba(255,85,85,0.1);border:1px solid rgba(255,85,85,0.3);border-radius:10px;padding:10px 14px;color:var(--danger);font-size:0.8rem;margin-bottom:14px;}
  @media(max-width:600px){
    .hp-actions{gap:10px;}
    .hp-action-card{padding:14px;}
    .hp-action-title{font-size:0.88rem;}
    .hp-action-desc{font-size:0.7rem;}
    .hp-nav{padding:12px 14px;}
    .hp-logo-img{height:42px;}
    .hp-body{padding:20px 14px;}
    .hp-h1{font-size:1.6rem;}
    .hp-nav-btn{padding:6px 10px;font-size:0.72rem;}
    .hp-search-box{flex-direction:row;gap:8px;}
    .hp-room{padding:12px 14px;}
    .hp-room-icon{width:36px;height:36px;font-size:1rem;}
    .hp-uname{display:none;}
    .hp-room-meta{font-size:0.68rem;}
    .modal-box{border-radius:20px 20px 0 0;position:fixed;bottom:0;left:0;right:0;max-width:100%;margin:0;padding:24px 20px;}
    .modal-overlay{align-items:flex-end;padding:0;}
    .hp-filter-bar{gap:5px;margin-bottom:10px;}
    .hp-filter-btn{padding:4px 10px;font-size:0.68rem;}
    .hp-sort-select{font-size:0.68rem;padding:4px 8px;margin-left:0;width:100%;}
  }
  @media(max-width:400px){
    .hp-actions{grid-template-columns:1fr;}
    .hp-nav-right{gap:4px;}
    .hp-nav-btn.wallet{padding:6px 8px;}
    .hp-wallet-bal{font-size:0.65rem;}
    .hp-search-btn{padding:12px 14px;font-size:0.82rem;}
    .hp-room-right{gap:4px;}
    .hp-filter-bar{display:grid;grid-template-columns:repeat(3,1fr);}
    .hp-sort-select{grid-column:1/-1;}
  }
  @media(max-width:340px){
    .hp-nav-btn span:not(.hp-wallet-bal){display:none;}
    .hp-search-box{flex-direction:column;}
    .hp-h1{font-size:1.4rem;}
  }
`;

const STATUS_LABELS = {
  created: "รอชำระเงิน",
  deposited: "รอจัดส่ง",
  shipped: "กำลังส่ง",
  confirmed: "รับของแล้ว",
  completed: "เสร็จสิ้น",
  released: "เสร็จสิ้น",
  refunded: "คืนเงินแล้ว",
  disputed: "ข้อพิพาท",
};

function generateCode() {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789"; // ไม่มี O/0/I/1
  let code = "";
  for (let i = 0; i < 6; i++) code += chars[Math.floor(Math.random() * chars.length)];
  return code;
}

export default function HomePage({ view = "overview" }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false);
  const [itemName, setItemName] = useState("");
  const [price, setPrice] = useState("");
  const [role, setRole] = useState("buyer");
  const [dealType, setDealType] = useState("physical"); // "physical" | "digital"
  const [creating, setCreating] = useState(false);
  const [createTerms, setCreateTerms] = useState(false);
  const [searchCode, setSearchCode] = useState("");
  const [searching, setSearching] = useState(false);
  const [searchError, setSearchError] = useState("");
  const [toast, setToast] = useState("");
  const [createError, setCreateError] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [filterRole, setFilterRole]     = useState("all");
  const [sortBy, setSortBy]             = useState("newest");

  const user = readCachedUser();
  const [walletBalance, setWalletBalance] = useState(0);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [ownsCoupons, setOwnsCoupons] = useState(false);

  useEffect(() => {
    const type = searchParams.get("create");
    if (type === "physical" || type === "digital") {
      setDealType(type);
      setShowCreate(true);
      setSearchParams({}, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  // Real-time wallet balance + check isAdmin + auto-detect province
  useEffect(() => {
    if (!user.uid) return;
    const doneFirst = perfMark("HomePage: onSnapshot(users/me) ครั้งแรก");
    let first = true;
    const unsub = onSnapshot(doc(db, "users", user.uid), (snap) => {
      if (first) { doneFirst("exists=" + snap.exists()); first = false; }
      if (snap.exists()) {
        const d = snap.data();
        setWalletBalance(d.wallet_balance || 0);
        setIsAdmin(d.isAdmin === true);

      }
    }, (err) => {
      if (first) { doneFirst("error: " + err.code); first = false; }
      console.error("[HomePage] user listener error:", err);
    });
    return () => unsub();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // มีคูปองของสมาชิก (เป็นเจ้าของ) หรือไม่ — แสดงเมนู "คูปองของฉัน" เฉพาะคนที่เป็นเจ้าของ
  useEffect(() => {
    if (!user.uid) return;
    return onSnapshot(
      query(collection(db, "coupons"), where("ownerId", "==", user.uid)),
      (snap) => setOwnsCoupons(!snap.empty),
      () => {}
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!user.uid) {
      navigate("/login");
      return;
    }
    const doneFirst = perfMark("HomePage: onSnapshot(rooms) ครั้งแรก");
    let first = true;
    const q = query(
      collection(db, "rooms"),
      where("members", "array-contains", user.uid),
      orderBy("createdAt", "desc"),
    );
    return onSnapshot(q, (snap) => {
      if (first) { doneFirst(snap.size + " ห้อง"); first = false; }
      setRooms(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      setLoading(false);
    }, (err) => {
      if (first) { doneFirst("error: " + err.code); first = false; }
      console.error("[HomePage] rooms listener error:", err);
      setLoading(false);
      if (err.code === "permission-denied" || err.code === "unauthenticated") {
        localStorage.removeItem("klang-user");
        navigate("/login");
      }
    });
  }, [user.uid, navigate]);

  const showToast = (msg) => {
    setToast(msg);
    setTimeout(() => setToast(""), 2500);
  };

  // สร้างห้องใหม่
  const handleCreate = async () => {
    if (!itemName.trim() || !price) return;
    if (!Number.isSafeInteger(Number(price)) || Number(price) <= 0 || Number(price) > 1000000) {
      setCreateError("ราคาสินค้าต้องเป็นจำนวนเต็มตั้งแต่ 1 ถึง 1,000,000 บาท"); return;
    }
    setCreating(true);
    setCreateError("");
    try {
      const code = generateCode();
      const creatorName = user.name || user.displayName || user.email?.split("@")[0] || "ผู้ใช้";
      const ref = await addDoc(collection(db, "rooms"), {
        itemName: itemName.trim(),
        price: Number(price),
        status: "created",
        dealType, // "physical" | "digital" — สินค้าดิจิทัลข้ามขั้นตอนแจ้งเลขพัสดุ/รูปแพ็ก
        roomCode: code,
        buyerId: role === "buyer" ? user.uid : null,
        buyerName: role === "buyer" ? creatorName : null,
        sellerId: role === "seller" ? user.uid : null,
        sellerName: role === "seller" ? creatorName : null,
        members: [user.uid],
        createdAt: serverTimestamp(),
        createdBy: user.uid,
      });
      await addDoc(collection(db, "rooms", ref.id, "messages"), {
        text: `ห้องแชทถูกสร้างแล้ว · สินค้า: ${itemName.trim()} · ราคา ฿${Number(price).toLocaleString()} · รหัสห้อง: ${code}`,
        type: "system",
        senderId: "system",
        createdAt: serverTimestamp(),
      });
      navigate(`/chat/${ref.id}`);
    } catch (err) {
      setCreateError("สร้างห้องไม่สำเร็จ กรุณาลองใหม่");
    }
    setCreating(false);
  };

  // ค้นหาห้องด้วย Room Code
  const handleSearch = async () => {
    if (!searchCode.trim()) return;
    setSearching(true);
    setSearchError("");
    try {
      const existing = rooms.find(room => room.roomCode === searchCode.trim().toUpperCase());
      if (existing) {
        navigate(`/chat/${existing.id}`);
        setSearching(false);
        return;
      }
      const q = query(
        collection(db, "rooms"),
        where("roomCode", "==", searchCode.trim().toUpperCase()),
        where("status", "==", "created"),
      );
      const snap = await getDocs(q);
      if (snap.empty) {
        setSearchError("ไม่พบห้องที่มีรหัสนี้ กรุณาตรวจสอบอีกครั้ง");
      } else {
        const roomDoc = snap.docs[0];
        navigate(`/chat/${roomDoc.id}`);
      }
    } catch {
      setSearchError("เกิดข้อผิดพลาด กรุณาลองใหม่");
    }
    setSearching(false);
  };

  const copyCode = (code) => {
    navigator.clipboard.writeText(code);
    showToast(`คัดลอกรหัส ${code} แล้ว ✓`);
  };

  const handleLogout = async () => {
    await signOut(auth);
    localStorage.removeItem("klang-user");
    navigate("/");
  };

  return (
    <div className="hp">
      <style>{css}</style>

      {/* Nav */}
      <nav className="hp-nav">
        <div className="hp-logo" onClick={() => navigate("/home")} style={{cursor:"pointer"}}>
          <span className="kl-wordmark">klang.</span>
        </div>
        <div className="hp-nav-right">
          {/* Wallet Button */}
          <button
            className="hp-nav-btn wallet"
            onClick={() => navigate("/wallet")}
          >
            <Icon name="wallet" size={16} />{" "}
            <span className="hp-wallet-bal">
              ฿{walletBalance.toLocaleString()}
            </span>
          </button>

          {/* Notification Bell */}
          <NotificationBell />

          {/* Profile Dropdown */}
          <div className="hp-profile-dropdown">
            <div
              className="hp-av"
              style={{ cursor: "pointer" }}
              onClick={() => setShowProfileMenu((v) => !v)}
            >
              {(user.name || user.email || "?")[0].toUpperCase()}
            </div>
            {showProfileMenu && (
              <div
                className="hp-profile-menu"
                onClick={() => setShowProfileMenu(false)}
              >
                <div
                  style={{
                    padding: "8px 12px 8px",
                    fontSize: "0.78rem",
                    color: "var(--text-muted)",
                    borderBottom: "1px solid var(--border)",
                    marginBottom: 4,
                  }}
                >
                  <div
                    style={{
                      fontWeight: 600,
                      color: "var(--text)",
                      marginBottom: 2,
                    }}
                  >
                    {user.name || "ผู้ใช้งาน"}
                  </div>
                  <div>{user.email}</div>
                </div>
                <button
                  className="hp-profile-item"
                  onClick={() => navigate("/wallet")}
                >
                  <Icon name="wallet" size={16} /> กระเป๋าเงิน
                </button>
                <button
                  className="hp-profile-item"
                  onClick={() => navigate("/profile")}
                >
                  <Icon name="user" size={16} /> โปรไฟล์
                </button>
                <button
                  className="hp-profile-item"
                  onClick={() => navigate("/transactions")}
                >
                  <Icon name="chart" size={16} /> ประวัติธุรกรรม
                </button>
                {ownsCoupons && (
                  <button
                    className="hp-profile-item"
                    onClick={() => navigate("/my-coupons")}
                  >
                    <Icon name="ticket" size={16} /> คูปองของฉัน
                  </button>
                )}
                {isAdmin && (
                  <button
                    className="hp-profile-item"
                    onClick={() => navigate("/admin")}
                    style={{ color: "#dc3728" }}
                  >
                    <Icon name="shield" size={16} /> แผงควบคุม Admin
                  </button>
                )}
                <div className="hp-divider" />
                <button
                  className="hp-profile-item danger"
                  onClick={handleLogout}
                >
                  <Icon name="logout" size={16} /> ออกจากระบบ
                </button>
              </div>
            )}
          </div>
        </div>
      </nav>

      <div className="hp-body">
        <h1 className="hp-h1">
          {view === "rooms" ? "ห้องซื้อขายของฉัน" : "ภาพรวม"}
        </h1>
        <p className="hp-sub">
          สร้างดีลใหม่ หรือเข้าร่วมห้องที่มีอยู่ด้วยรหัสห้อง
        </p>

        {view === "overview" && <div className="kl-dashboard-stats">
          <div className="kl-stat"><span>ยอดเงินในกระเป๋า</span><strong>฿{walletBalance.toLocaleString()}</strong></div>
          <div className="kl-stat"><span>ดีลที่กำลังดำเนินการ</span><strong>{rooms.filter(r => ["created", "deposited", "shipped", "disputed"].includes(r.status)).length} ดีล</strong></div>
          <div className="kl-stat"><span>ดีลสำเร็จ</span><strong>{rooms.filter(r => ["released", "completed"].includes(r.status)).length} รายการ</strong></div>
        </div>}

        {/* Action Cards */}
        <div className="hp-actions">
          <div
            className="hp-action-card primary"
            role="button" tabIndex={0}
            onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setDealType("physical"); setShowCreate(true); } }}
            onClick={() => { setDealType("physical"); setShowCreate(true); }}
          >
            <div className="hp-action-icon"><Icon name="box" size={26} /></div>
            <div className="hp-action-title">สร้างห้องซื้อขายทั่วไป</div>
            <div className="hp-action-desc">
              สินค้าที่ต้องจัดส่งจริง ผู้ขายแนบหลักฐานการส่ง ระบบสร้างรหัสห้องให้อัตโนมัติ
            </div>
            <span className="kl-card-cta">สร้างห้องซื้อขาย</span>
          </div>
          <div
            className="hp-action-card game"
            role="button" tabIndex={0}
            onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setDealType("digital"); setShowCreate(true); } }}
            onClick={() => { setDealType("digital"); setShowCreate(true); }}
          >
            <div className="hp-action-icon"><Icon name="gamepad" size={26} /></div>
            <div className="hp-action-title">สร้างห้องรหัสเกม</div>
            <div className="hp-action-desc">
              ไอดีเกม รหัสเติมเกม บัญชี — ส่งมอบรหัสผ่านแชท ไม่ต้องจัดส่งพัสดุ
            </div>
            <span className="kl-card-cta">สร้างห้องรหัสเกม</span>
          </div>
        </div>

        {/* Search Box */}
        <div className="hp-search-box">
          <input
            id="search-input"
            className="hp-search-input"
            placeholder="กรอกรหัสห้อง เช่น AB1C2D"
            value={searchCode}
            onChange={(e) => {
              setSearchCode(e.target.value.toUpperCase());
              setSearchError("");
            }}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            maxLength={6}
          />
          <button
            className="hp-search-btn"
            onClick={handleSearch}
            disabled={searching}
          >
            {searching ? "กำลังค้นหา..." : "เข้าร่วม →"}
          </button>
        </div>
        {searchError && <div className="error-msg">{searchError}</div>}

        {/* Room List */}
        <div className="hp-sec-label">ห้องแชทของคุณ ({rooms.length})</div>

        {/* Filter & Sort Bar */}
        {!loading && rooms.length > 0 && (() => {
          const statusFilters = [
            { key: "all", label: "ทั้งหมด" },
            { key: "created", label: "รอชำระ" },
            { key: "deposited", label: "รอจัดส่ง" },
            { key: "shipped", label: "กำลังส่ง" },
            { key: "released", label: "เสร็จสิ้น" },
            { key: "disputed", label: "ข้อพิพาท" },
          ];
          return (
            <div className="hp-filter-bar">
              {statusFilters.map(f => (
                <button key={f.key} className={`hp-filter-btn${filterStatus === f.key ? " active" : ""}`}
                  onClick={() => setFilterStatus(f.key)}>{f.label}</button>
              ))}
              <button className={`hp-filter-btn${filterRole === "buyer" ? " active" : ""}`}
                onClick={() => setFilterRole(r => r === "buyer" ? "all" : "buyer")}>ผู้ซื้อ</button>
              <button className={`hp-filter-btn${filterRole === "seller" ? " active" : ""}`}
                onClick={() => setFilterRole(r => r === "seller" ? "all" : "seller")}>ผู้ขาย</button>
              <select className="hp-sort-select" value={sortBy} onChange={e => setSortBy(e.target.value)}>
                <option value="newest">ใหม่สุด</option>
                <option value="oldest">เก่าสุด</option>
                <option value="price_high">ราคา ↓</option>
                <option value="price_low">ราคา ↑</option>
              </select>
            </div>
          );
        })()}

        {loading ? (
          <div className="hp-loading">
            <div className="hp-spinner" /> กำลังโหลด...
          </div>
        ) : rooms.length === 0 ? (
          <div className="hp-empty">
            <div className="hp-empty-icon"><Icon name="message" size={40} /></div>
            <div className="hp-empty-title">ยังไม่มีห้องแชท</div>
            <div className="hp-empty-sub">
              กดสร้างห้องแชทใหม่ หรือกรอกรหัสห้องเพื่อเข้าร่วม
            </div>
          </div>
        ) : (() => {
          let filtered = rooms
            .filter(r => filterStatus === "all" || (filterStatus === "released" ? ["released", "completed"].includes(r.status) : r.status === filterStatus))
            .filter(r => filterRole === "all" || (filterRole === "buyer" ? r.buyerId === user.uid : r.sellerId === user.uid));
          if (sortBy === "oldest")    filtered = [...filtered].sort((a,b) => (a.createdAt?.seconds||0) - (b.createdAt?.seconds||0));
          else if (sortBy === "price_high") filtered = [...filtered].sort((a,b) => (b.price||0) - (a.price||0));
          else if (sortBy === "price_low")  filtered = [...filtered].sort((a,b) => (a.price||0) - (b.price||0));
          if (filtered.length === 0) return (
            <div className="hp-empty">
              <div className="hp-empty-icon"><Icon name="search" size={40} /></div>
              <div className="hp-empty-title">ไม่พบห้องที่ตรงกัน</div>
              <div className="hp-empty-sub">ลองเปลี่ยน Filter</div>
            </div>
          );
          return (
          <div className="hp-rooms">
            {filtered.map((room) => {
              const statusCls = room.status || "created";
              const statusLabel = STATUS_LABELS[room.status] || room.status;
              return (
                <div
                  key={room.id}
                  className="hp-room"
                  tabIndex={0}
                  role="link"
                  aria-label={`เปิดห้อง ${room.itemName}`}
                  onKeyDown={(event) => { if (event.target === event.currentTarget && event.key === "Enter") navigate(`/chat/${room.id}`); }}
                  onClick={() => navigate(`/chat/${room.id}`)}
                >
                  <div className="hp-room-icon"><Icon name={room.dealType === "digital" ? "gamepad" : "box"} size={20} /></div>
                  <div className="hp-room-info">
                    <div className="hp-room-name">{room.itemName}</div>
                    <div className="hp-room-meta">
                      ฿{(room.price || 0).toLocaleString()} ·{" "}
                      {room.buyerId === user.uid ? "ผู้ซื้อ" : "ผู้ขาย"}
                      {room.createdAt?.toDate &&
                        ` · ${room.createdAt.toDate().toLocaleDateString("th-TH")}`}
                    </div>
                    {room.roomCode && (
                      <div>
                        <span className="hp-room-code">
                          รหัส: {room.roomCode}
                        </span>
                        <button
                          className="hp-copy-btn"
                          style={{ marginLeft: 8 }}
                          onClick={(e) => {
                            e.stopPropagation();
                            copyCode(room.roomCode);
                          }}
                        >
                          คัดลอก
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="hp-room-right">
                    <span className={`hp-badge ${statusCls}`}>
                      {statusLabel}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
          );
        })()}
      </div>

      {/* Modal สร้างห้อง */}
      {showCreate && (
        <div
          className="modal-overlay"
          onClick={(e) => e.target === e.currentTarget && setShowCreate(false)}
        >
          <aside className="kl-form-summary"><h2>สรุปค่าใช้จ่าย</h2><div><span>ราคาสินค้า</span><strong>฿{(Number(price)||0).toLocaleString()}</strong></div><div><span>ค่าธรรมเนียม</span><strong>฿{Number(price) >= 1000 ? 100 : 50}</strong></div><div className="kl-form-total"><span>ยอดที่ผู้ซื้อชำระ</span><strong>฿{((Number(price)||0)+(Number(price)>=1000?100:50)).toLocaleString()}</strong></div><p>ระบบจะพักเงินไว้จนกว่าผู้ซื้อจะยืนยันรับสินค้า</p></aside>
          <div className="modal-box">
            <button type="button" className="kl-form-back" onClick={() => setShowCreate(false)} disabled={creating}>
              <span aria-hidden="true">←</span> ย้อนกลับ
            </button>
            <div className="modal-title">
              {dealType === "digital" ? "สร้างห้องรหัสเกม" : "สร้างห้องซื้อขายทั่วไป"}
            </div>
            <div className="modal-sub">
              {dealType === "digital"
                ? "เช่น ไอดีเกม รหัสเติมเกม บัญชี — ผู้ขายส่งรหัส/ข้อมูลผ่านแชทแทนการจัดส่งพัสดุจริง ระบบจะสร้างรหัสห้องให้อัตโนมัติ"
                : "ระบบจะสร้างรหัสห้องให้อัตโนมัติ ส่งให้อีกฝ่ายเพื่อเข้าร่วม"}
            </div>

            {createError && <div className="error-msg">{createError}</div>}

            <div className="form-group">
              <label className="form-label">คุณเป็นใคร?</label>
              <div className="role-btns">
                <button
                  className={`role-btn${role === "buyer" ? " active" : ""}`}
                  onClick={() => setRole("buyer")}
                >
                  ผู้ซื้อ
                </button>
                <button
                  className={`role-btn${role === "seller" ? " active" : ""}`}
                  onClick={() => setRole("seller")}
                >
                  ผู้ขาย
                </button>
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">ชื่อสินค้า</label>
              <input
                className="form-input"
                placeholder={dealType === "digital" ? "เช่น ไอดี Rov เลเวล 30, รหัสเติม Steam 500" : "เช่น iPhone 15 Pro, PS5 มือสอง"}
                value={itemName}
                onChange={(e) => setItemName(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label className="form-label">ราคาสินค้า (บาท)</label>
              <input
                className="form-input"
                type="number"
                min={1} max={1000000} step={1}
                placeholder="เช่น 15000"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
              />
            </div>

            {/* ── Terms & Conditions ── */}
            <div className="create-terms-box">
              <h4>ข้อกำหนดและเงื่อนไขการใช้งาน Klang</h4>
              <p><strong>1. ระบบ Escrow:</strong> Klang ทำหน้าที่เป็นตัวกลางถือเงิน ผู้ขายจะได้รับเงินก็ต่อเมื่อผู้ซื้อยืนยันรับสินค้าแล้ว หรือครบ 7 วันนับจากวันที่จัดส่ง</p>
              <p><strong>2. ค่าธรรมเนียม:</strong> ราคาต่ำกว่า ฿1,000 คิด ฿50 คงที่ / ฿1,000 ขึ้นไปคิด ฿100 คงที่ ชำระโดยผู้ซื้อ (ไม่คืนเงินค่าธรรมเนียมในทุกกรณี)</p>
              <p><strong>3. การจัดส่ง:</strong> {dealType === "digital"
                ? "สินค้าดิจิทัลส่งมอบผ่านแชททันที ไม่ต้องแนบเลขพัสดุหรือรูปกล่อง"
                : "ผู้ขายต้องจัดส่งสินค้าภายใน 3 วันนับจากที่ได้รับเงิน พร้อมแนบหลักฐานการส่ง (วีดีโอ + รูปกล่อง)"}</p>
              <p><strong>4. การรับสินค้า:</strong> ผู้ซื้อต้องตรวจสอบและยืนยันภายใน {dealType === "digital" ? "24 ชั่วโมง" : "7 วัน"} มิฉะนั้นระบบจะโอนเงินให้ผู้ขายอัตโนมัติ</p>
              <p><strong>5. ข้อพิพาท:</strong> หากมีปัญหา ผู้ซื้อสามารถเรียกร้องได้ภายใน 7 วัน ทีม Klang จะตรวจสอบและตัดสินภายใน 24 ชั่วโมง</p>
              <p><strong>6. ความรับผิดชอบ:</strong> Klang ไม่รับผิดชอบความเสียหายที่เกิดจากการกระทำของผู้ใช้งานที่ฝ่าฝืนข้อตกลง</p>
            </div>

            <label className={`create-terms-check${createTerms ? " checked" : ""}`}>
              <input
                type="checkbox"
                checked={createTerms}
                onChange={(e) => setCreateTerms(e.target.checked)}
              />
              ฉันได้อ่านและยอมรับข้อกำหนดและเงื่อนไขการใช้งาน Klang แล้ว
            </label>

            <div className="modal-btns">
              <button
                className="btn-cancel"
                onClick={() => {
                  setShowCreate(false);
                  setCreateError("");
                  setCreateTerms(false);
                  setDealType("physical");
                }}
              >
                ยกเลิก
              </button>
              <button
                className="btn-ok"
                onClick={handleCreate}
                disabled={!itemName.trim() || !price || creating || !createTerms}
              >
                {creating ? "กำลังสร้าง..." : "สร้างห้องแชท →"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Toast */}
      {toast && <div className="toast">{toast}</div>}
      <FloatingContact />
    </div>
  );
}
